import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Footer() {
  const location = useLocation();
  const isWorkActive =
    location.pathname === "/" || location.pathname === "/work";
  const isAboutActive = location.pathname === "/about";

  return (
    <footer>
      <div className="footer-border">
        <nav className="footer-nav">
          <Link
            to="/work"
            className={isWorkActive ? "active" : ""}
            aria-current={isWorkActive ? "page" : undefined}
          >
            Work
          </Link>
          <Link
            to="/about"
            className={isAboutActive ? "active" : ""}
            aria-current={isAboutActive ? "page" : undefined}
          >
            About
          </Link>
        </nav>
      </div>
    </footer>
  );
}
